import { useQuery } from '@hooks/reactQuery';

import { getGroups, getSeverities } from '@api/common';

import { optionsFormatted } from '@utils/formatter';

import { IAlarmByVendorFilter, IAlarmFilter } from '@interfaces/alarms/alarm';
import { TNameTitle } from '@interfaces/common/common';
import { TSelectOption } from '@interfaces/components/componentTypes';
import { TSelectOptionType } from '@components/common/Select/Select.types';

import { EVendorsValues } from '@enums/common';

import { refetchOptions } from '@constants/common';
import {
	ALARM_GROUPS,
	ALARM_SEVERITIES,
} from '@constants/queryKeys';
import { statusAlarmHistoryOptions } from '@components/routes/AdminPanel/Alarms/AlarmByVendor/constants';

import { IAlarmFiltersProps } from './useActiveAlarmFilters';

export const useQueryLimenetActiveAlarmFilters = ({
	vendor,
	isActiveTab,
}: IAlarmFiltersProps): IAlarmByVendorFilter => {
	const isEnabled = vendor === EVendorsValues.limenet;

	const {
		data: severities,
		isInitialLoading: isLoadingSeverities,
	} = useQuery<Array<TNameTitle>, TSelectOption<string>[]>({
		queryKey: [ALARM_SEVERITIES],
		queryFn: getSeverities,
		select: (severities) => optionsFormatted<TNameTitle>(severities),
		enabled: [isEnabled],
		...refetchOptions,
	});

	const {
		data: groups,
		isInitialLoading: isLoadingGroups,
	} = useQuery<Array<TNameTitle>, TSelectOptionType<string>[]>({
		queryKey: [ALARM_GROUPS],
		queryFn: getGroups,
		select: (groups) => optionsFormatted<TNameTitle>(groups),
		enabled: [isEnabled],
		...refetchOptions,
	});

	const activeFilters: IAlarmFilter[] = isEnabled ? [
		{
			name: 'severity',
			placeholder: 'Severity',
			data: severities || [],
		},
		{
			name: 'group',
			placeholder: 'Group',
			data: groups || [],
		},

	] : [];

	const filters = !isActiveTab
		? [
			...activeFilters,
			{
				name: 'status',
				placeholder: 'Status',
				data: !isActiveTab ? statusAlarmHistoryOptions : [],
			},
		] : activeFilters;

	return {
		filters,
		isLoading: isLoadingGroups || isLoadingSeverities,
	};
};
